import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import StyleModule from './modules/StyleModule'

Vue.use(Vuex)
let vuexLocal = null
if (process.browser) {
  if (window.localStorage.vuex) {
    const vuex = JSON.parse(window.localStorage.vuex)
    const { darkMode } = vuex.Style
    delete vuex.Style
    vuex.Style = {
      darkMode
    }
    window.localStorage.setItem('vuex', JSON.stringify(vuex))
  }
  vuexLocal = new VuexPersistence({
    storage: window.localStorage
  })
}

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Style: StyleModule
  },
  plugins: [
    vuexLocal.plugin
  ]
})
